'use client';
import React from 'react';
import { PersonIcon } from '@modules/common/icons/person';
import { Tooltip } from 'react-tooltip';

type NextArrowProps = {
  place_id: string,
  author_display_name?: string,
  size?: number,
  topClass?: string,
  leftClass?: string,
}

export const PersonTag = ({
                            place_id = '',
                            size = 25,
                            topClass = 'top-4',
                            leftClass = 'left-4',
                            author_display_name = '',
                          }: NextArrowProps) => {
  return (
    <>{author_display_name ?
      <div className="relative z-10">
        <div className={`${place_id} absolute ${leftClass} ${topClass}`}>
          <PersonIcon size={size}></PersonIcon>
        </div>
        <Tooltip anchorSelect={`.${place_id}`} place="top" className="z-20">
          Photo by {` ${author_display_name}`}

        </Tooltip>
      </div>
      : <></>
    }</>
  );
};